import "./styles.css";
import { useState } from "react";

import slika1Hero from "./assets/images/slika1-hero.jpg";
import slika2Logatec from "./assets/images/slika2-logatec.jpg";
import slika3Krsko from "./assets/images/slika3-krsko.jpg";
import slika4Koper from "./assets/images/slika4-koper.jpg";
import slika5Obiskovalci from "./assets/images/slika5-obiskovalci.jpg";
import slika6Vozniki from "./assets/images/slika6-vozniki.jpg";
import slika7Live from "./assets/images/slika7-live.jpg";

import pdfCasovnica from "./assets/PDF 1 - casovnica.pdf";
import pdfIzjavaPress from "./assets/PDF 2 - Izjava press.pdf";
import pdfRazpis from "./assets/PDF 3 - Razpis.pdf";
import pdfTehnicni from "./assets/PDF 4 - Tehnicni pravilnik.pdf";
import pdfSodniski from "./assets/PDF 5 - Sodniski pravilnik.pdf";
import pdfTekmovalni from "./assets/PDF 6 - Tekmovalni pravilnik.pdf";
import pdfCallEn from "./assets/Call.pdf";
import pdfTechnicalEn from "./assets/Technical.pdf";
import pdfJudicialEn from "./assets/Judical.pdf";
import pdfCompetitionEn from "./assets/Competition.pdf";
import pdfPrivacy from "./assets/DRIFT DREAMS KLUB - politika zasebnosti.pdf";

import logoRavenol from "./assets/images/ravenol.png";
import logoMonster from "./assets/images/monster.PNG";
import logoBlagomix from "./assets/images/blagomix.jpg";
import logoTunersCapital from "./assets/images/tuners-capital.png";
import logoDeltabloc from "./assets/images/deltabloc.png";
import logoAsSlo from "./assets/images/as-slo.png";
import logoPrangl from "./assets/images/prangl.jpg";

const driverFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSc6kBYNxrfKrb2HNaXmb-bSJjaGRxVXRhCz9ZpH9ex2OVMDCQ/viewform?embedded=true";

const eventimLink = "https://www.eventim.si/artist/driftstars/";
const liveStreamLink = "https://www.youtube.com/@DriftDreamsKlub/streams";

const translations = {
  sl: {
    brandSubtitle: "SLOVENIA DRIFT CHAMPIONSHIP",
    nav: {
      info: "INFO",
      races: "TEKME",
      results: "REZULTATI",
      regulations: "PRAVILNIKI",
      registrations: "REGISTRACIJE",
      spectators: "Obiskovalci",
      drivers: "Vozniki",
      press: "Press",
      about: "O prvenstvu",
      logatec: "#1 Logatec",
      krsko: "#2 Krško",
      koper: "#3 Koper",
      call: "Razpis",
      technical: "Tehnični",
      judicial: "Sodniški",
      competition: "Tekmovalni",
      prizes: "Nagrade",
    },
    headerActions: {
      live: "🔴 LIVE",
      buyTickets: "KUPI KARTE",
    },
    hero: {
      eyebrow: "ODPRTO DRŽAVNO PRVENSTVO SLOVENIJE V DRIFTU",
      paragraph:
        "Najvišji nivo drifta v regiji. Vrhunski vozniki, močna atmosfera, uradno prvenstvo in platforma, ki povezuje šport, avtomobilsko kulturo in sodobne digitalne medije.",
      buyTickets: "🎟️ KUPI VSTOPNICE",
      calendar: "📅 KOLEDAR",
      liveStream: "▶️ LIVE STREAM",
    },
    quickEntry: {
      spectatorsTitle: "GLEDALCI",
      spectatorsText:
        "Vstopnice, program, doživetje dogodka in informacije za obisk.",
      driversTitle: "VOZNIKI",
      driversText:
        "Divizije, osnovna pravila, predstavitev voznikov in prijave.",
      pressTitle: "PRESS",
      pressText: "Akreditacije, kontakt, materiali za medije in objave.",
      open: "ODPRI SEKCIJO →",
    },
    racesSection: {
      kicker: "TEKME",
      title: "KOLEDAR 2026",
      buyTicketsLink: "KUPI VSTOPNICE →",
      readMore: "PREBERI VEČ →",
    },
    raceCards: {
      logatec: {
        title: "#1 LOGATEC",
        date: "23.–24. 5. 2026",
        place: "Blagomix Racing Park",
        text: "Legendarno tekmovališče gosti drift že od leta 2004.",
      },
      krsko: {
        title: "#2 KRŠKO",
        date: "20.–21. 6. 2026",
        place: "Raceland Krško",
        text: "Poletna dirka z močnim ritmom sezone.",
      },
      koper: {
        title: "#3 KOPER – FINALE",
        date: "7.–8. 11. 2026",
        place: "Bonifika, Koper",
        text: "Finale ob morju z mednarodno udeležbo. V sodelovanju z Z-Brothers.",
      },
    },
    eventDetail: {
      logatec: {
        kicker: "#1 LOGATEC",
        title: "Otvoritvena dirka sezone",
        text:
          "23.–24. 5. 2026 · Blagomix Racing Park. Legendarno tekmovališče, kjer drift živi že od leta 2004.",
      },
      krsko: {
        kicker: "#2 KRŠKO",
        title: "Druga dirka sezone",
        text:
          "20.–21. 6. 2026 · Raceland Krško. Poletna dirka z močnim ritmom sezone.",
      },
      koper: {
        kicker: "#3 KOPER – FINALE",
        title: "Finale ob morju",
        text:
          "7.–8. 11. 2026 · Bonifika, Koper. Finale ob morju z mednarodno udeležbo. V sodelovanju z Z-Brothers.",
      },
      buyTickets: "Kupi karte",
      schedule: "Časovnica",
      raceland: "Raceland",
      maps: "Google Maps",
    },
    about: {
      kicker: "O PRVENSTVU",
      title: "DRIFT STARS JE VEČ KOT DOGODEK",
      p1:
        "Drift Stars je uradno odprto državno prvenstvo Slovenije v driftu pod okriljem AŠ SLO (FIA). Združuje vrhunske voznike, profesionalno organizacijo in mednarodno udeležbo.",
      p2:
        "Projekt presega klasično tekmovanje — predstavlja platformo, ki povezuje avtomobilistično kulturo, varno mobilnost in sodobne digitalne medije.",
    },
    stats: {
      kicker: "DOSEG",
      title: "DRIFT STARS V ŠTEVILKAH",
      visitors: "obiskovalcev na dogodek",
      international: "mednarodno",
      drivers: "udeleženi vozniki",
      ig: "Instagram doseg / sezona",
      fb: "Facebook doseg / sezona",
    },
    live: {
      kicker: "V ŽIVO",
      title: "LIVE STREAM",
      text: "Link za live stream kmalu.",
      open: "ODPREJ PRENOS",
      pressMaterials: "PRESS MATERIALI",
      badge: "LIVE STREAM",
    },
    spectators: {
      kicker: "INFO / OBISKOVALCI",
      title: "DOŽIVI DRIFT",
      text:
        "Vonj po gumah, zvok motorjev in milimetrska natančnost voznikov ustvarijo edinstveno izkušnjo. Drift terapija v živo: kvalifikacije, boji dvojic, taxi vožnje, car show, spremljevalni program, hrana in pijača.",
      list: [
        "Drift tekmovanje",
        "Taxi vožnje",
        "Car show",
        "Stunt motorji",
        "Hrana & pijača",
      ],
      newKicker: "NOVO 2026",
      favoriteTitle: "FAVORITE DRIVER",
      favoriteText: "Nagradno glasovanje za najljubšega voznika.",
      favoriteList: [
        "5x 2 vstopnici za naslednjo tekmo",
        "3x majica Drift Stars",
        "3x podpisana kartica zmagovalca tekme DIV 1 in DIV 2",
      ],
      buyNow: "KUPI KARTE ZDAJ",
    },
    press: {
      kicker: "INFO / PRESS",
      title: "ZA MEDIJE",
      p1:
        "Sekcija za medije in partnerje. Spodbujamo medijsko aktivnost. Naši dogodki so polni energije in akcije.",
      contact: "Kontakt:",
      accreditation: "AKREDITACIJA",
      pressContact: "PRESS KONTAKT",
      mediaKit: "MEDIA KIT",
      statements: "IZJAVE IN OBJAVE",
    },
    regulations: {
      kicker: "PRAVILNIKI",
      title: "URADNI DOKUMENTI",
      call: "RAZPIS",
      technical: "TEHNIČNI",
      judicial: "SODNIŠKI",
      competition: "TEKMOVALNI",
    },
    prizes: {
      kicker: "NAGRADE",
      title: "NAGRADNI SKLAD",
      place: "Mesto",
      favorite: "Favorite driver",
    },
    results: {
      kicker: "REZULTATI",
      empty2026: "Še ni rezultatov. Tukaj bo prostor za razpredelnice po dirkah.",
      empty2025:
        "Prostor za tabelo rezultatov: mesto, ime, kvalifikacije, dvojice, skupno.",
    },
    registrations: {
      kicker: "REGISTRACIJE",
      title: "PRIJAVE",
      drivers: "PRIJAVA VOZNIKI",
      press: "PRIJAVA PRESS",
    },
    sponsors: {
      kicker: "SPONZORJI & PARTNERJI",
      title: "S PODPORO",
      mainLabel: "GLAVNA SPONZORJA",
      partnersLabel: "PARTNERJI",
      monsterPlaceholder: "MONSTER",
    },
    driverModal: {
      title: "PRIJAVA VOZNIKA",
      close: "Zapri",
      loading: "Nalagam obrazec…",
    },
    footer: {
      poweredBy: "Powered by",
      about: "O prvenstvu",
      races: "Tekme",
      press: "Press",
      top: "Na vrh",
      privacy: "Politika zasebnosti",
    },
    privacy: {
      kicker: "PRAVNO",
      title: "POLITIKA ZASEBNOSTI",
      back: "← Nazaj na stran",
      download: "Prenesi PDF",
      org: "DRIFT DREAMS KLUB",
      orgAddress: "Gestrinova ulica 7, 1000 Ljubljana",
      orgId: "Matična številka: 2712792",
      orgEmail: "info@drift-dreams.si",
      orgWeb: "www.drift-stars.si",
      date: "V Ljubljani, dne 26. 3. 2026",
      sections: [
        {
          title: "1. Upravljavec osebnih podatkov",
          paragraphs: [
            "Upravljavec osebnih podatkov je:",
            "DRIFT DREAMS KLUB, Gestrinova ulica 7, 1000 Ljubljana, info@drift-dreams.si (v nadaljevanju: društvo).",
          ],
        },
        {
          title: "2. Katere osebne podatke zbiramo",
          paragraphs: ["Društvo lahko zbira in obdeluje naslednje osebne podatke:"],
          list: [
            "ime in priimek",
            "e-mail naslov",
            "telefonska številka",
            "datum rojstva",
            "podatki o vozilu (v primeru prijave na dogodek)",
            "kontakt v sili",
            "podatki o prijavi in udeležbi na dogodkih",
            "morebitni drugi podatki, ki jih posameznik prostovoljno posreduje",
          ],
        },
        {
          title: "3. Namen obdelave osebnih podatkov",
          paragraphs: ["Osebne podatke obdelujemo za naslednje namene:"],
          list: [
            "organizacija in izvedba drift dogodkov (treningi, tekmovanja)",
            "vodenje evidenc udeležencev",
            "komunikacija z udeleženci",
            "obdelava prijav in plačil",
            "zagotavljanje varnosti na dogodkih",
            "izpolnjevanje zakonskih obveznosti",
          ],
        },
        {
          title: "4. Pravna podlaga za obdelavo",
          paragraphs: ["Osebne podatke obdelujemo na podlagi:"],
          list: [
            "izvajanja dejavnosti društva",
            "zakonitega interesa (organizacija dogodkov, promocija)",
            "privolitve posameznika (kjer je to potrebno)",
          ],
        },
        {
          title: "5. Fotografiranje in snemanje",
          paragraphs: [
            "Dogodki v organizaciji društva so javne narave, zato se lahko na njih izvaja fotografiranje in snemanje.",
            "Posnetki in fotografije se lahko uporabljajo za:",
          ],
          list: [
            "objave na spletni strani društva",
            "objave na družbenih omrežjih",
            "promocijske materiale društva",
            "poročanje o dogodkih",
          ],
          paragraphsAfter: [
            "Društvo si prizadeva, da posamezniki niso izpostavljeni na neprimeren ali škodljiv način.",
            "Posameznik lahko zahteva odstranitev konkretne fotografije ali posnetka, če za to obstajajo utemeljeni razlogi.",
          ],
        },
        {
          title: "6. Uporabniki osebnih podatkov",
          paragraphs: ["Dostop do osebnih podatkov imajo:"],
          list: [
            "člani upravnega odbora društva",
            "člani delovne skupine za organizacijo dogodkov",
            "pogodbeni sodelavci (npr. sodniki, tehnična ekipa), kadar je to potrebno",
            "pristojni organi, če to zahteva zakon",
          ],
          paragraphsAfter: ["Vsi navedeni so dolžni varovati zaupnost podatkov."],
        },
        {
          title: "7. Hramba osebnih podatkov",
          paragraphs: ["Osebne podatke hranimo le toliko časa, kolikor je potrebno za:"],
          list: [
            "izvedbo dogodka",
            "izpolnjevanje zakonskih obveznosti",
            "zaščito pravnih interesov društva",
          ],
          paragraphsAfter: ["Po preteku roka se podatki izbrišejo ali anonimizirajo."],
        },
        {
          title: "8. Varovanje osebnih podatkov",
          paragraphs: [
            "Društvo zagotavlja ustrezne organizacijske in tehnične ukrepe za zaščito osebnih podatkov pred:",
          ],
          list: ["nepooblaščenim dostopom", "izgubo ali uničenjem", "zlorabo"],
        },
        {
          title: "9. Pravice posameznika",
          paragraphs: ["Posameznik ima pravico do:"],
          list: [
            "dostopa do svojih osebnih podatkov",
            "popravka netočnih podatkov",
            "izbrisa podatkov (kjer je to mogoče)",
            "omejitve obdelave",
            "ugovora obdelavi",
            "prenosljivosti podatkov",
          ],
          paragraphsAfter: ["Zahtevo lahko posameznik poda na e-mail društva."],
        },
        {
          title: "10. Končne določbe",
          paragraphs: [
            "Društvo si pridržuje pravico do spremembe te politike zasebnosti.",
            "Aktualna verzija je vedno dostopna na spletni strani društva.",
          ],
        },
      ],
    },
  },
  en: {
    brandSubtitle: "SLOVENIA DRIFT CHAMPIONSHIP",
    nav: {
      info: "INFO",
      races: "RACES",
      results: "RESULTS",
      regulations: "REGULATIONS",
      registrations: "REGISTRATIONS",
      spectators: "Spectators",
      drivers: "Drivers",
      press: "Press",
      about: "About the championship",
      logatec: "#1 Logatec",
      krsko: "#2 Krško",
      koper: "#3 Koper",
      call: "Call",
      technical: "Technical",
      judicial: "Judicial",
      competition: "Competition",
      prizes: "Prizes",
    },
    headerActions: {
      live: "🔴 LIVE",
      buyTickets: "BUY TICKETS",
    },
    hero: {
      eyebrow: "SLOVENIAN OPEN DRIFT CHAMPIONSHIP",
      paragraph:
        "The highest level of drifting in the region. Top drivers, strong atmosphere, an official championship and a platform that connects sport, automotive culture and modern digital media.",
      buyTickets: "🎟️ BUY TICKETS",
      calendar: "📅 CALENDAR",
      liveStream: "▶️ LIVE STREAM",
    },
    quickEntry: {
      spectatorsTitle: "SPECTATORS",
      spectatorsText:
        "Tickets, program, event experience and visitor information.",
      driversTitle: "DRIVERS",
      driversText:
        "Divisions, basic rules, driver introductions and registrations.",
      pressTitle: "PRESS",
      pressText: "Accreditations, contact, media materials and publications.",
      open: "OPEN SECTION →",
    },
    racesSection: {
      kicker: "RACES",
      title: "2026 CALENDAR",
      buyTicketsLink: "BUY TICKETS →",
      readMore: "READ MORE →",
    },
    raceCards: {
      logatec: {
        title: "#1 LOGATEC",
        date: "23–24 May 2026",
        place: "Blagomix Racing Park",
        text: "A legendary venue hosting drift events since 2004.",
      },
      krsko: {
        title: "#2 KRŠKO",
        date: "20–21 June 2026",
        place: "Raceland Krško",
        text: "Summer race with the strong rhythm of the season.",
      },
      koper: {
        title: "#3 KOPER – FINALE",
        date: "7–8 November 2026",
        place: "Bonifika, Koper",
        text: "Seaside finale with international participation. In partnership with Z-Brothers.",
      },
    },
    eventDetail: {
      logatec: {
        kicker: "#1 LOGATEC",
        title: "Season opener",
        text:
          "23–24 May 2026 · Blagomix Racing Park. A legendary venue where drift has lived since 2004.",
      },
      krsko: {
        kicker: "#2 KRŠKO",
        title: "Second race of the season",
        text:
          "20–21 June 2026 · Raceland Krško. A summer race with the strong rhythm of the season.",
      },
      koper: {
        kicker: "#3 KOPER – FINALE",
        title: "Seaside finale",
        text:
          "7–8 November 2026 · Bonifika, Koper. Seaside finale with international participation. In partnership with Z-Brothers.",
      },
      buyTickets: "Buy tickets",
      schedule: "Schedule",
      raceland: "Raceland",
      maps: "Google Maps",
    },
    about: {
      kicker: "ABOUT THE CHAMPIONSHIP",
      title: "DRIFT STARS IS MORE THAN AN EVENT",
      p1:
        "Drift Stars is the official open national drift championship of Slovenia under AŠ SLO (FIA). It brings together top drivers, professional organization and international participation.",
      p2:
        "The project goes beyond a classic competition — it is a platform that connects automotive culture, road safety and modern digital media.",
    },
    stats: {
      kicker: "REACH",
      title: "DRIFT STARS IN NUMBERS",
      visitors: "spectators per event",
      international: "international",
      drivers: "participating drivers",
      ig: "Instagram reach / season",
      fb: "Facebook reach / season",
    },
    live: {
      kicker: "LIVE",
      title: "LIVE STREAM",
      text: "Live stream link coming soon.",
      open: "OPEN STREAM",
      pressMaterials: "PRESS MATERIALS",
      badge: "LIVE STREAM",
    },
    spectators: {
      kicker: "INFO / SPECTATORS",
      title: "EXPERIENCE DRIFT",
      text:
        "The smell of tires, the sound of engines and millimeter precision of drivers create a unique experience. Live drift therapy: qualifications, twin battles, taxi rides, car show, supporting program, food and drinks.",
      list: [
        "Drift competition",
        "Taxi rides",
        "Car show",
        "Stunt motorcycles",
        "Food & drinks",
      ],
      newKicker: "NEW IN 2026",
      favoriteTitle: "FAVORITE DRIVER",
      favoriteText: "Prize voting for your favorite driver.",
      favoriteList: [
        "5x 2 tickets for the next race",
        "3x Drift Stars t-shirt",
        "3x signed card of the DIV 1 and DIV 2 race winners",
      ],
      buyNow: "BUY TICKETS NOW",
    },
    press: {
      kicker: "INFO / PRESS",
      title: "FOR MEDIA",
      p1:
        "Section for media and partners. We encourage media activity. Our events are full of energy and action.",
      contact: "Contact:",
      accreditation: "ACCREDITATION",
      pressContact: "PRESS CONTACT",
      mediaKit: "MEDIA KIT",
      statements: "STATEMENTS & RELEASES",
    },
    regulations: {
      kicker: "REGULATIONS",
      title: "OFFICIAL DOCUMENTS",
      call: "CALL",
      technical: "TECHNICAL",
      judicial: "JUDICIAL",
      competition: "COMPETITION",
    },
    prizes: {
      kicker: "PRIZES",
      title: "PRIZE FUND",
      place: "Place",
      favorite: "Favorite driver",
    },
    results: {
      kicker: "RESULTS",
      empty2026: "No results yet. This will host race-by-race tables.",
      empty2025:
        "Space for results table: place, name, qualifications, twin battles, total.",
    },
    registrations: {
      kicker: "REGISTRATIONS",
      title: "ENTRIES",
      drivers: "DRIVER ENTRY",
      press: "PRESS ENTRY",
    },
    sponsors: {
      kicker: "SPONSORS & PARTNERS",
      title: "WITH THE SUPPORT OF",
      mainLabel: "MAIN SPONSORS",
      partnersLabel: "PARTNERS",
      monsterPlaceholder: "MONSTER",
    },
    driverModal: {
      title: "DRIVER REGISTRATION",
      close: "Close",
      loading: "Loading form…",
    },
    footer: {
      poweredBy: "Powered by",
      about: "About",
      races: "Races",
      press: "Press",
      top: "To top",
      privacy: "Privacy policy",
    },
    privacy: {
      kicker: "LEGAL",
      title: "PRIVACY POLICY",
      back: "← Back to site",
      download: "Download PDF",
      org: "DRIFT DREAMS KLUB",
      orgAddress: "Gestrinova ulica 7, 1000 Ljubljana, Slovenia",
      orgId: "Registration No.: 2712792",
      orgEmail: "info@drift-dreams.si",
      orgWeb: "www.drift-stars.si",
      date: "Ljubljana, 26 March 2026",
      sections: [
        {
          title: "1. Data controller",
          paragraphs: [
            "The controller of personal data is:",
            "DRIFT DREAMS KLUB, Gestrinova ulica 7, 1000 Ljubljana, info@drift-dreams.si (hereinafter: the association).",
          ],
        },
        {
          title: "2. Personal data we collect",
          paragraphs: ["The association may collect and process the following personal data:"],
          list: [
            "first and last name",
            "email address",
            "phone number",
            "date of birth",
            "vehicle information (when registering for an event)",
            "emergency contact",
            "registration and event participation data",
            "any other data the individual provides voluntarily",
          ],
        },
        {
          title: "3. Purpose of processing",
          paragraphs: ["We process personal data for the following purposes:"],
          list: [
            "organisation and execution of drift events (training, competitions)",
            "keeping records of participants",
            "communication with participants",
            "processing of registrations and payments",
            "ensuring safety at events",
            "fulfilment of legal obligations",
          ],
        },
        {
          title: "4. Legal basis for processing",
          paragraphs: ["We process personal data on the basis of:"],
          list: [
            "the activities of the association",
            "legitimate interest (event organisation, promotion)",
            "the consent of the individual (where required)",
          ],
        },
        {
          title: "5. Photography and recording",
          paragraphs: [
            "Events organised by the association are public in nature, so photography and recording may take place.",
            "Recordings and photographs may be used for:",
          ],
          list: [
            "publications on the association's website",
            "publications on social media",
            "the association's promotional materials",
            "event reporting",
          ],
          paragraphsAfter: [
            "The association strives to ensure that individuals are not exposed in an inappropriate or harmful way.",
            "An individual may request the removal of a specific photograph or recording where there are justified reasons.",
          ],
        },
        {
          title: "6. Recipients of personal data",
          paragraphs: ["Access to personal data is granted to:"],
          list: [
            "members of the association's management board",
            "members of the working group for event organisation",
            "contractual partners (e.g. judges, technical crew) when necessary",
            "competent authorities, when required by law",
          ],
          paragraphsAfter: ["All of the above are required to maintain confidentiality."],
        },
        {
          title: "7. Retention of personal data",
          paragraphs: ["We retain personal data only as long as necessary for:"],
          list: [
            "carrying out the event",
            "fulfilling legal obligations",
            "protecting the association's legal interests",
          ],
          paragraphsAfter: ["After the retention period, data is deleted or anonymised."],
        },
        {
          title: "8. Data protection",
          paragraphs: [
            "The association implements appropriate organisational and technical measures to protect personal data against:",
          ],
          list: ["unauthorised access", "loss or destruction", "misuse"],
        },
        {
          title: "9. Rights of the individual",
          paragraphs: ["The individual has the right to:"],
          list: [
            "access their personal data",
            "rectification of inaccurate data",
            "erasure of data (where possible)",
            "restriction of processing",
            "object to processing",
            "data portability",
          ],
          paragraphsAfter: ["Requests can be submitted to the association's email address."],
        },
        {
          title: "10. Final provisions",
          paragraphs: [
            "The association reserves the right to amend this privacy policy.",
            "The current version is always available on the association's website.",
          ],
        },
      ],
    },
  },
};

export default function App() {
  const [openMenu, setOpenMenu] = useState(null);
  const [lang, setLang] = useState("sl");
  const [view, setView] = useState("main");
  const [showDriverModal, setShowDriverModal] = useState(false);
  const t = translations[lang];

  const partnerLogos = [
    { src: logoBlagomix, alt: "Blagomix Racing Park" },
    { src: logoTunersCapital, alt: "Tuners Capital" },
    { src: logoDeltabloc, alt: "DeltaBloc" },
    { src: logoAsSlo, alt: "AŠ SLO" },
    { src: logoPrangl, alt: "Prangl" },
  ];

  const goPrivacy = (e) => {
    if (e) e.preventDefault();
    setView("privacy");
    setOpenMenu(null);
    if (typeof window !== "undefined") window.scrollTo({ top: 0 });
  };

  const goMain = (e) => {
    if (e) e.preventDefault();
    setView("main");
    if (typeof window !== "undefined") window.scrollTo({ top: 0 });
  };

  const openDriverModal = (e) => {
    if (e) e.preventDefault();
    setShowDriverModal(true);
    setOpenMenu(null);
  };

  const regulationsPdfs =
    lang === "en"
      ? {
          call: pdfCallEn,
          technical: pdfTechnicalEn,
          judicial: pdfJudicialEn,
          competition: pdfCompetitionEn,
        }
      : {
          call: pdfRazpis,
          technical: pdfTehnicni,
          judicial: pdfSodniski,
          competition: pdfTekmovalni,
        };

  const menus = [
    {
      label: t.nav.info,
      items: [
        { name: t.nav.spectators, href: "#obiskovalci" },
        { name: t.nav.drivers, href: "#vozniki" },
        { name: t.nav.press, href: "#press" },
        { name: t.nav.about, href: "#o-prvenstvu" },
      ],
    },
    {
      label: t.nav.races,
      items: [
        { name: t.nav.logatec, href: "#logatec" },
        { name: t.nav.krsko, href: "#krsko" },
        { name: t.nav.koper, href: "#koper" },
      ],
    },
    {
      label: t.nav.results,
      items: [
        { name: "2026", href: "#rezultati-2026" },
        { name: "2025", href: "#rezultati-2025" },
      ],
    },
    {
      label: t.nav.regulations,
      items: [
        { name: t.nav.call, href: "#pravilniki" },
        { name: t.nav.technical, href: "#pravilniki" },
        { name: t.nav.judicial, href: "#pravilniki" },
        { name: t.nav.competition, href: "#pravilniki" },
        { name: t.nav.prizes, href: "#nagrade" },
      ],
    },
    {
      label: t.nav.registrations,
      items: [
        { name: t.nav.drivers, href: "#registracije" },
        { name: t.nav.press, href: "#press" },
      ],
    },
  ];

  const raceCards = [
    { id: "logatec", image: slika2Logatec, ...t.raceCards.logatec },
    { id: "krsko", image: slika3Krsko, ...t.raceCards.krsko },
    { id: "koper", image: slika4Koper, ...t.raceCards.koper },
  ];

  return (
    <div className="app">
      <div className="bg-layer" />

      <header className="navbar">
        <a href="#top" className="brand">
          <div className="brand-mark">★</div>
          <div>
            <div className="brand-title">DRIFT STARS</div>
            <div className="brand-subtitle">{t.brandSubtitle}</div>
          </div>
        </a>

        <nav className="nav desktop-nav">
          {menus.map((menu) => (
            <div
              key={menu.label}
              className="nav-item"
              onMouseEnter={() => setOpenMenu(menu.label)}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <button className="nav-button">{menu.label}</button>

              <div
                className={`dropdown ${
                  openMenu === menu.label ? "dropdown-open" : ""
                }`}
              >
                {menu.items.map((item) => (
                  <a key={item.name} href={item.href} className="dropdown-link">
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </nav>

        <div className="header-actions">
          <div className="lang-switcher" role="group" aria-label="Language">
            <button
              type="button"
              className={`lang-button ${lang === "sl" ? "lang-button-active" : ""}`}
              onClick={() => setLang("sl")}
              aria-pressed={lang === "sl"}
            >
              SI
            </button>
            <button
              type="button"
              className={`lang-button ${lang === "en" ? "lang-button-active" : ""}`}
              onClick={() => setLang("en")}
              aria-pressed={lang === "en"}
            >
              EN
            </button>
          </div>

          <a href="#livestream" className="btn btn-ghost">
            {t.headerActions.live}
          </a>
          <a
            href={eventimLink}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary"
          >
            {t.headerActions.buyTickets}
          </a>
        </div>
      </header>

      <main id="top" style={{ display: view === "privacy" ? "none" : undefined }}>
        <section
          className="hero"
          style={{
            backgroundImage: `linear-gradient(90deg, rgba(8,8,12,0.88) 0%, rgba(8,8,12,0.58) 45%, rgba(8,8,12,0.28) 100%), url(${slika1Hero})`,
          }}
        >
          <div className="hero-overlay" />
          <div className="hero-content">
            <div className="eyebrow">{t.hero.eyebrow}</div>

            <h1>DRIFT STARS</h1>

            <p>{t.hero.paragraph}</p>

            <div className="social-links">
              <a
                href="https://www.instagram.com/driftdreamsklub/"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61558667394950"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://www.tiktok.com/@driftdreamsklub"
                target="_blank"
                rel="noreferrer"
              >
                TikTok
              </a>
              <a
                href="https://www.youtube.com/channel/UC8KNa3-MMAn8S1XCxTl9u2A"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>
            </div>

            <div className="hero-buttons">
              <a
                href={eventimLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.hero.buyTickets}
              </a>
              <a href="#tekme" className="btn btn-dark">
                {t.hero.calendar}
              </a>
              <a href="#livestream" className="btn btn-ghost">
                {t.hero.liveStream}
              </a>
            </div>
          </div>
        </section>

        <section className="quick-entry">
          <a href="#obiskovalci" className="entry-card">
            <div className="entry-icon">🎟️</div>
            <h2>{t.quickEntry.spectatorsTitle}</h2>
            <p>{t.quickEntry.spectatorsText}</p>
            <span>{t.quickEntry.open}</span>
          </a>

          <a href="#vozniki" className="entry-card">
            <div className="entry-icon">🏁</div>
            <h2>{t.quickEntry.driversTitle}</h2>
            <p>{t.quickEntry.driversText}</p>
            <span>{t.quickEntry.open}</span>
          </a>

          <a href="#press" className="entry-card">
            <div className="entry-icon">📰</div>
            <h2>{t.quickEntry.pressTitle}</h2>
            <p>{t.quickEntry.pressText}</p>
            <span>{t.quickEntry.open}</span>
          </a>
        </section>

        <section id="tekme" className="section">
          <div className="section-head">
            <div>
              <div className="section-kicker">{t.racesSection.kicker}</div>
              <h2>{t.racesSection.title}</h2>
            </div>
            <a
              href={eventimLink}
              target="_blank"
              rel="noreferrer"
              className="simple-link"
            >
              {t.racesSection.buyTicketsLink}
            </a>
          </div>

          <div className="race-grid">
            {raceCards.map((race) => (
              <a key={race.id} href={`#${race.id}`} className="race-card">
                <div
                  className="race-image"
                  style={{ backgroundImage: `url(${race.image})` }}
                />
                <div className="race-content">
                  <div className="race-date">{race.date}</div>
                  <h3>{race.title}</h3>
                  <div className="race-place">{race.place}</div>
                  <p>{race.text}</p>
                  <span>{t.racesSection.readMore}</span>
                </div>
              </a>
            ))}
          </div>
        </section>

        <section id="logatec" className="section event-detail">
          <div
            className="event-detail-image"
            style={{ backgroundImage: `url(${slika2Logatec})` }}
          />
          <div className="glass-card">
            <div className="section-kicker">{t.eventDetail.logatec.kicker}</div>
            <h2>{t.eventDetail.logatec.title}</h2>
            <p>{t.eventDetail.logatec.text}</p>
            <div className="button-row">
              <a
                href={eventimLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.eventDetail.buyTickets}
              </a>
              <a
                href={pdfCasovnica}
                target="_blank"
                rel="noreferrer"
                className="btn btn-dark"
              >
                {t.eventDetail.schedule}
              </a>
            </div>
          </div>
        </section>

        <section id="krsko" className="section event-detail">
          <div
            className="event-detail-image"
            style={{ backgroundImage: `url(${slika3Krsko})` }}
          />
          <div className="glass-card">
            <div className="section-kicker">{t.eventDetail.krsko.kicker}</div>
            <h2>{t.eventDetail.krsko.title}</h2>
            <p>{t.eventDetail.krsko.text}</p>
            <div className="button-row">
              <a
                href={eventimLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.eventDetail.buyTickets}
              </a>
              <a
                href="https://raceland.si/"
                target="_blank"
                rel="noreferrer"
                className="btn btn-dark"
              >
                {t.eventDetail.raceland}
              </a>
            </div>
          </div>
        </section>

        <section id="koper" className="section event-detail">
          <div
            className="event-detail-image"
            style={{ backgroundImage: `url(${slika4Koper})` }}
          />
          <div className="glass-card">
            <div className="section-kicker">{t.eventDetail.koper.kicker}</div>
            <h2>{t.eventDetail.koper.title}</h2>
            <p>{t.eventDetail.koper.text}</p>
            <div className="button-row">
              <a
                href={eventimLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.eventDetail.buyTickets}
              </a>
              <a
                href="https://maps.app.goo.gl/UQbqNAUJJxCaWMLEA"
                target="_blank"
                rel="noreferrer"
                className="btn btn-dark"
              >
                {t.eventDetail.maps}
              </a>
            </div>
          </div>
        </section>

        <section id="o-prvenstvu" className="section two-col">
          <div className="glass-card title-card">
            <div className="section-kicker">{t.about.kicker}</div>
            <h2>{t.about.title}</h2>
          </div>

          <div className="glass-card text-card">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
          </div>
        </section>

        <section className="section stats">
          <div className="section-kicker">{t.stats.kicker}</div>
          <h2>{t.stats.title}</h2>

          <div className="stats-grid">
            <div className="stat-box">
              <strong>1.500+</strong>
              <span>{t.stats.visitors}</span>
            </div>
            <div className="stat-box">
              <strong>{t.stats.international}</strong>
              <span>{t.stats.drivers}</span>
            </div>
            <div className="stat-box">
              <strong>2,98 M</strong>
              <span>{t.stats.ig}</span>
            </div>
            <div className="stat-box">
              <strong>2,2 M</strong>
              <span>{t.stats.fb}</span>
            </div>
          </div>
        </section>

        <section id="livestream" className="section livestream-section">
          <div className="video-box">
            <div
              className="video-placeholder"
              style={{
                backgroundImage: `linear-gradient(135deg, rgba(123,63,228,0.24), rgba(8,8,12,0.55)), url(${slika7Live})`,
              }}
            >
              <div className="play-badge">{t.live.badge}</div>
            </div>
          </div>

          <div className="glass-card livestream-copy">
            <div className="section-kicker">{t.live.kicker}</div>
            <h2>{t.live.title}</h2>
            <p>{t.live.text}</p>
            <div className="button-row">
              <a
                href={liveStreamLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.live.open}
              </a>
              <a href="#press" className="btn btn-dark">
                {t.live.pressMaterials}
              </a>
            </div>
          </div>
        </section>

        <section id="obiskovalci" className="section info-grid">
          <div className="glass-card">
            <div
              className="section-image"
              style={{ backgroundImage: `url(${slika5Obiskovalci})` }}
            />
            <div className="section-kicker">{t.spectators.kicker}</div>
            <h2>{t.spectators.title}</h2>
            <p>{t.spectators.text}</p>
            <ul>
              {t.spectators.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div id="tickets" className="ticket-card">
            <div className="section-kicker">{t.spectators.newKicker}</div>
            <h2>{t.spectators.favoriteTitle}</h2>
            <p>{t.spectators.favoriteText}</p>
            <ul>
              {t.spectators.favoriteList.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <a
              href={eventimLink}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              {t.spectators.buyNow}
            </a>
          </div>
        </section>

        <section id="press" className="section press-layout">
          <div className="glass-card">
            <div className="section-kicker">{t.press.kicker}</div>
            <h2>{t.press.title}</h2>
            <p>{t.press.p1}</p>
            <p>
              {t.press.contact} <strong>press@drift-stars.si</strong>
            </p>
          </div>

          <div className="press-grid">
            <a href="#!" className="press-box">
              {t.press.accreditation}
            </a>
            <a href="mailto:press@drift-stars.si" className="press-box">
              {t.press.pressContact}
            </a>
            <a href="#!" className="press-box">
              {t.press.mediaKit}
            </a>
            <a
              href={pdfIzjavaPress}
              target="_blank"
              rel="noreferrer"
              className="press-box"
            >
              {t.press.statements}
            </a>
          </div>
        </section>

        <section id="pravilniki" className="section">
          <div className="section-kicker">{t.regulations.kicker}</div>
          <h2>{t.regulations.title}</h2>
          <div className="press-grid">
            <a
              href={regulationsPdfs.call}
              target="_blank"
              rel="noreferrer"
              className="press-box"
            >
              {t.regulations.call}
            </a>
            <a
              href={regulationsPdfs.technical}
              target="_blank"
              rel="noreferrer"
              className="press-box"
            >
              {t.regulations.technical}
            </a>
            <a
              href={regulationsPdfs.judicial}
              target="_blank"
              rel="noreferrer"
              className="press-box"
            >
              {t.regulations.judicial}
            </a>
            <a
              href={regulationsPdfs.competition}
              target="_blank"
              rel="noreferrer"
              className="press-box"
            >
              {t.regulations.competition}
            </a>
          </div>
        </section>

        <section id="nagrade" className="section">
          <div className="section-kicker">{t.prizes.kicker}</div>
          <h2>{t.prizes.title}</h2>
          <div className="prize-table-wrap">
            <table className="prize-table">
              <thead>
                <tr>
                  <th>{t.prizes.place}</th>
                  <th>DIV 1</th>
                  <th>DIV 2</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>1.000 €</td>
                  <td>1.200 €</td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>700 €</td>
                  <td>800 €</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>450 €</td>
                  <td>500 €</td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>250 €</td>
                  <td>300 €</td>
                </tr>
                <tr>
                  <td>{t.prizes.favorite}</td>
                  <td>150 €</td>
                  <td>150 €</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section id="rezultati-2026" className="section">
          <div className="section-kicker">{t.results.kicker}</div>
          <h2>2026</h2>
          <div className="glass-card">
            <p>{t.results.empty2026}</p>
          </div>
        </section>

        <section id="rezultati-2025" className="section">
          <div className="section-kicker">{t.results.kicker}</div>
          <h2>2025</h2>
          <div className="glass-card">
            <p>{t.results.empty2025}</p>
          </div>
        </section>

        <section id="sponzorji" className="section sponsors-section">
          <div className="section-kicker">{t.sponsors.kicker}</div>
          <h2>{t.sponsors.title}</h2>

          <div className="sponsors-tier-label">{t.sponsors.mainLabel}</div>
          <div className="sponsors-main-grid">
            <div className="sponsor sponsor-main">
              <img src={logoRavenol} alt="Ravenol" className="sponsor-logo" />
            </div>
            <div className="sponsor sponsor-main">
              <img src={logoMonster} alt="Monster" className="sponsor-logo" />
            </div>
          </div>

          <div className="sponsors-tier-label">{t.sponsors.partnersLabel}</div>
          <div className="sponsors-grid">
            {partnerLogos.map((s) => (
              <div key={s.alt} className="sponsor">
                <img src={s.src} alt={s.alt} className="sponsor-logo" />
              </div>
            ))}
          </div>
        </section>

        <section id="registracije" className="section">
          <div className="section-kicker">{t.registrations.kicker}</div>
          <h2>{t.registrations.title}</h2>
          <div className="press-grid">
            <a href="#!" onClick={openDriverModal} className="press-box">
              {t.registrations.drivers}
            </a>
            <a href="#press" className="press-box">
              {t.registrations.press}
            </a>
          </div>
        </section>
      </main>

      {view === "privacy" && (
        <main id="top" className="privacy-page">
          <section className="section">
            <div className="section-kicker">{t.privacy.kicker}</div>
            <h2>{t.privacy.title}</h2>

            <div className="privacy-meta glass-card">
              <div className="privacy-org">{t.privacy.org}</div>
              <div>{t.privacy.orgAddress}</div>
              <div>{t.privacy.orgId}</div>
              <div>
                <a href="mailto:info@drift-dreams.si">{t.privacy.orgEmail}</a>
                {" · "}
                <a href="https://www.drift-stars.si" target="_blank" rel="noreferrer">
                  {t.privacy.orgWeb}
                </a>
              </div>
            </div>

            <div className="privacy-actions">
              <a href="#top" onClick={goMain} className="btn btn-ghost">
                {t.privacy.back}
              </a>
              <a
                href={pdfPrivacy}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                {t.privacy.download}
              </a>
            </div>

            <div className="privacy-content">
              {t.privacy.sections.map((sec) => (
                <div key={sec.title} className="privacy-section">
                  <h3>{sec.title}</h3>
                  {sec.paragraphs &&
                    sec.paragraphs.map((p, i) => <p key={`p-${i}`}>{p}</p>)}
                  {sec.list && (
                    <ul>
                      {sec.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {sec.paragraphsAfter &&
                    sec.paragraphsAfter.map((p, i) => (
                      <p key={`pa-${i}`}>{p}</p>
                    ))}
                </div>
              ))}
              <p className="privacy-date">{t.privacy.date}</p>
              <p className="privacy-date">{t.privacy.org}</p>
            </div>
          </section>
        </main>
      )}

      <footer className="footer">
        <div>
          <div className="footer-title">DRIFT STARS</div>
          <div className="footer-subtitle">
            {t.footer.poweredBy}{" "}
            <a
              href="https://www.drift-dreams.si/"
              target="_blank"
              rel="noreferrer"
            >
              Drift Dreams Klub
            </a>
          </div>
          <div className="footer-subtitle">info@drift-stars.si</div>
        </div>

        <div className="footer-links">
          <a href="#o-prvenstvu" onClick={view === "privacy" ? goMain : undefined}>
            {t.footer.about}
          </a>
          <a href="#tekme" onClick={view === "privacy" ? goMain : undefined}>
            {t.footer.races}
          </a>
          <a href="#press" onClick={view === "privacy" ? goMain : undefined}>
            {t.footer.press}
          </a>
          <a href="#privatnost" onClick={goPrivacy}>
            {t.footer.privacy}
          </a>
          <a href="#top" onClick={view === "privacy" ? goMain : undefined}>
            {t.footer.top}
          </a>
        </div>
      </footer>

      {showDriverModal && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={t.driverModal.title}
          onClick={() => setShowDriverModal(false)}
        >
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{t.driverModal.title}</div>
              <button
                type="button"
                className="modal-close"
                onClick={() => setShowDriverModal(false)}
                aria-label={t.driverModal.close}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <iframe
                src={driverFormUrl}
                title={t.driverModal.title}
                className="driver-form-iframe"
              >
                {t.driverModal.loading}
              </iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
